import React from 'react';
import { FormattedMessage } from 'react-intl';

export const anywhereInWorld = (
    <FormattedMessage id="shippingHelpers.rest_of_world" defaultMessage="anywhere in the world" />
);

export const leadTimeMessage = (
    <FormattedMessage
        id="pdp.PdpSharedBlurbShippingCustomQuote.leadTimeRequestQuote"
        defaultMessage=", excluding production time"
    />
);

export const ratesVary = (
    <FormattedMessage
        id="pdp.PdpSharedBlurbShippingCustomQuote.overviewRequestQuote"
        defaultMessage="Rates vary by destination and complexity."
    />
);

export const freeQuote = (
    <FormattedMessage
        id="pdp.PdpSharedBlurbShippingCustomQuote.freeShipping"
        defaultMessage="Free "
    />
);

export const quotePending = customQuoteShippingAddress => (
    <FormattedMessage
        id="pdp.PdpSharedBlurbShippingCustomQuote.overviewPendingDetails"
        defaultMessage="Quote pending to {customQuoteShippingAddress}"
        values={{ customQuoteShippingAddress }}
    />
);

export const quotePrice = price => (
    <FormattedMessage
        id="pdp.PdpSharedBlurbShippingCustomQuote.overviewPrice"
        defaultMessage="{price} "
        values={{ price }}
    />
);

export const quoteMethod = method => (
    <FormattedMessage
        id="pdp.PdpSharedBlurbShippingCustomQuote.overviewMethod"
        defaultMessage="{method} Shipping "
        values={{ method }}
    />
);

export const quoteRegion = region => (
    <FormattedMessage
        id="pdp.PdpSharedBlurbShippingCustomQuote.overviewRegion"
        defaultMessage="to {region}, "
        values={{ region }}
    />
);

export const quoteHandlingTime = handlingTime => (
    <FormattedMessage
        id="pdp.PdpSharedBlurbShippingCustomQuote.overviewTime"
        defaultMessage="arrives in {handlingTime}"
        values={{ handlingTime }}
    />
);

export const REGION_CODES = {
    REST_OF_WORLD: 'REST_OF_WORLD',
};

const frontDoorTooltipMessage = (
    <FormattedMessage
        id="shippingHelpers.frontDoorTooltip"
        defaultMessage="Delivered to the first available dry area outside of your house or building (front door, porch, landing area, garage, etc.)."
    />
);

const frontDoorDeliveryTooltipMessage = (
    <FormattedMessage
        id="shippingHelpers.frontDoorDeliveryTooltip"
        defaultMessage="Delivered to the first available dry area outside of your house or building (front door, porch, landing area, garage, etc.)."
    />
);

const messengerTooltipMessage = (
    <FormattedMessage
        id="shippingHelpers.messengerTooltip"
        defaultMessage="Item collected and hand-delivered via a local messenger service."
    />
);

const courierTooltipMessage = (
    <FormattedMessage
        id="shippingHelpers.courierTooltip"
        defaultMessage="Item collected and hand-delivered via a local courier service."
    />
);

const expressTooltipMessage = (
    <FormattedMessage
        id="shippingHelpers.expressTooltip"
        defaultMessage="Delivered by a parcel delivery service such as UPS, FedEx, or DHL."
    />
);

const standardTooltipMessage = (
    <FormattedMessage
        id="shippingHelpers.standardTooltip"
        defaultMessage="Delivered by a parcel delivery service such as UPS, FedEx, or DHL."
    />
);

const whiteGloveTooltipMessage = (
    <FormattedMessage
        id="shippingHelpers.whiteGloveTooltip"
        defaultMessage="Delivered by appointment to the room of your choice."
    />
);

const expeditedWhiteGloveTooltipMessage = (
    <FormattedMessage
        id="shippingHelpers.expeditedWhiteGloveTooltip"
        defaultMessage="Delivered by appointment to the room of your choice."
    />
);

const dibsWhiteGloveTooltipMessage = (
    <FormattedMessage
        id="shippingHelpers.dibsWhiteGloveTooltip"
        defaultMessage="Delivered by appointment to the room of your choice."
    />
);

const dibsExpeditedWhiteGloveTooltipMessage = (
    <FormattedMessage
        id="shippingHelpers.dibsExpeditedWhiteGloveTooltip"
        defaultMessage="Delivered by appointment to the room of your choice."
    />
);

export const shippingMethodDescriptions = {
    'Front Door': frontDoorTooltipMessage,
    'Front Door Delivery': frontDoorDeliveryTooltipMessage,
    Messenger: messengerTooltipMessage,
    Courier: courierTooltipMessage,
    Express: expressTooltipMessage,
    Standard: standardTooltipMessage,
    'White Glove': whiteGloveTooltipMessage,
    'Expedited White Glove': expeditedWhiteGloveTooltipMessage,
    // the 1stdibs keys are being referenced from the
    // `ShipmentQuote.buyerServiceMethodDisplay` field
    // so this probably needs a BE change
    '1stdibs White Glove': dibsWhiteGloveTooltipMessage,
    '1stdibs Expedited White Glove': dibsExpeditedWhiteGloveTooltipMessage,
};
